import {IconButton} from 'platform/components';
import {Show} from 'platform/foundation';
import styled from 'styled-components';

import {prop} from 'ramda';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

import {DASHBOARD_TILE_CATALOGUE} from '../../consts/dashboardTileCatalogue';
import {DashboardTileId} from '../../types/DashboardTileId';
import {DashboardTileSize} from '../../types/DashboardTileSize';
import {isDashboardTileResizable} from '../../utils/isDashboardTileResizable';
import {DashboardTileSizeChooser} from './DashboardTileSizeChooser';

interface DashboardTileToolbarProps extends TestIdProps {
  tileId: DashboardTileId;
  size: DashboardTileSize;
  onResize: (id: DashboardTileId, size: DashboardTileSize) => void;
  onHide: (id: DashboardTileId) => void;
}

const StyledToolbarWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({theme}) => theme.getSize(1)};
  height: ${({theme}) => theme.getSize(12)};
  padding: 0 ${({theme}) => theme.getSize(2)};
  background: ${({theme}) => theme.colors.general.white};
  border-radius: ${({theme}) => theme.radii.medium};
  box-shadow: ${({theme}) => theme.shadows.elevation_2};
`;

export function DashboardTileToolbar(props: DashboardTileToolbarProps) {
  return (
    // The tile wrapper carries the dnd-kit drag listeners; toolbar pointer and key events must not
    // reach them, or Enter/Space on a toolbar button starts a keyboard drag instead of a click.
    <StyledToolbarWrapper
      onPointerDown={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <Show when={isDashboardTileResizable(props.tileId)}>
        <DashboardTileSizeChooser
          tileId={props.tileId}
          size={props.size}
          onResize={props.onResize}
          data-testid={props['data-testid']}
        />
      </Show>
      <IconButton
        icon="action/visibility_off"
        size="default"
        iconSize="large"
        aria-label={`${i18n.t('page.homepage.dashboardLayout.hideTile')}: ${i18n.t(prop(props.tileId, DASHBOARD_TILE_CATALOGUE).labelKey)}`}
        onClick={() => props.onHide(props.tileId)}
        data-testid={suffixTestId('hideTile', props)}
      />
    </StyledToolbarWrapper>
  );
}
